/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
export var ButtonSet = function ButtonSet(_ref) {
  var children = _ref.forgeDoc.children,
    render = _ref.render;
  return jsx("div", {
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    css: css({
      display: 'flex',
      flexWrap: 'wrap',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
      '> *': {
        marginTop: "var(--ds-space-100, 8px)",
        marginRight: "var(--ds-space-100, 8px)"
      },
      marginTop: "var(--ds-space-negative-100, -8px)",
      marginRight: "var(--ds-space-negative-100, -8px)"
    })
  }, children.map(render));
};